import {
  CmiDigestWatchlistCommunityDetail,
  CmiDigestWatchlistCommunityRow,
  CmiDigestWatchlistCommunityRun,
  CmiDigestWatchlistOverview,
  CmiDigestWatchlistRun,
  CmiDigestWatchlistType,
} from 'types/cmiDigestWatchlist';

import axios from '../config/axiosPrivate';

export const getCmiDigestWatchlistRuns = async (): Promise<CmiDigestWatchlistRun[]> => {
  const response = await axios.get('/cmi-digest/watchlist/runs/');
  return response.data;
};

export const getCmiDigestWatchlistRunOverview = async (runId: number): Promise<CmiDigestWatchlistOverview> => {
  const response = await axios.get(`/cmi-digest/watchlist/runs/${runId}/`);
  return response.data;
};

export const getCmiDigestWatchlistRunCommunities = async (
  runId: number,
  filters: { type: CmiDigestWatchlistType; search: string }
): Promise<CmiDigestWatchlistCommunityRow[]> => {
  const response = await axios.get(`/cmi-digest/watchlist/runs/${runId}/communities/`, { params: filters });
  return response.data;
};

export const getCmiDigestWatchlistRunCommunityDetail = async (
  runId: number,
  runCommunityId: number
): Promise<CmiDigestWatchlistCommunityDetail> => {
  const response = await axios.get(`/cmi-digest/watchlist/runs/${runId}/communities/${runCommunityId}/`);
  return response.data;
};

export const getCmiDigestWatchlistCommunityRuns = async (
  communityId: number
): Promise<CmiDigestWatchlistCommunityRun[]> => {
  const response = await axios.get(`/cmi-digest/watchlist/communities/${communityId}/runs/`);
  return response.data;
};
